<template>
  <van-popup
    v-model:show="downloadAppTipsPopupConfig.isShow"
    position="bottom"
    class="download-app-tips-popup"
    teleport="body"
  >
    <p>{{ downloadAppTipsPopupConfig.tipsText }}</p>
    <van-button class="btn" @click="handleDownloadApp">{{
      $t('downloadAppTips.DownloadApp')
    }}</van-button>
  </van-popup>
</template>
<!-- 下载App提示弹窗 -->
<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()

const publicStore = usePublicStore()
const { downloadAppTipsPopupConfig } = storeToRefs(publicStore)

// 监听路由，切换页面关闭弹窗
const router = useRouter()
router.afterEach(() => {
  // 重置
  publicStore.setDownloadAppTipsConfig(false, '', 'msg')
})

// 跳转应用市场,区分埋点，区分消息，通话，直播列表来源
function handleDownloadApp() {
  // const browser = common.checkVersion()
  // if (browser.ios || browser.iPhone || browser.iPad) {
  //   // 苹果
  //   switch (downloadAppTipsPopupConfig.value.trackingLogType) {
  //     case 'msg':
  //       eventTracking.eventLog(eventTracking.eventId.msg_go_to_appstore)
  //       break
  //     case 'call':
  //       eventTracking.eventLog(eventTracking.eventId.call_go_to_appstore)
  //       break
  //     case 'live':
  //       eventTracking.eventLog(eventTracking.eventId.live_go_to_appstore)
  //       break
  //   }
  // } else {
  //   // 谷歌
  //   switch (downloadAppTipsPopupConfig.value.trackingLogType) {
  //     case 'msg':
  //       eventTracking.eventLog(eventTracking.eventId.msg_go_to_google_play)
  //       break
  //     case 'call':
  //       eventTracking.eventLog(eventTracking.eventId.call_go_to_google_play)
  //       break
  //     case 'live':
  //       eventTracking.eventLog(eventTracking.eventId.live_go_to_google_play)
  //       break
  //   }
  // }
  // 延迟500是为了能触发埋点
  setTimeout(() => {
    location.href = runtimeConfig.public.downloadUrl
  }, 500)
}
</script>

<style lang="scss">
.download-app-tips-popup {
  padding: 18px 0 24px;
  background: #222222;
  border-radius: 20px 20px 0px 0px;
  text-align: center;
  @include font-style(18px, #fff);
  .btn {
    margin-top: 30px;
    @include wh(302px, 54px);
    background: #9b49f6;
    border-radius: 27px;
    @include font-style(18px, #fff);
    border: none;
  }
}
</style>
